import { apiClient } from '@/api/client';
import type { PaginatedResult } from '@/types/api';
import type { Forwarder, ForwarderListParams } from '@/features/forwarders/types';
import type { ForwarderFormValues } from '@/features/forwarders/schema';

export const forwardersApi = {
  list: async (params: ForwarderListParams): Promise<PaginatedResult<Forwarder>> =>
    (await apiClient.get<PaginatedResult<Forwarder>>('/forwarders', { params })).data,
  create: async (body: ForwarderFormValues): Promise<Forwarder> => (await apiClient.post<Forwarder>('/forwarders', body)).data,
  update: async (id: string, body: Partial<ForwarderFormValues>): Promise<Forwarder> => (await apiClient.patch<Forwarder>(`/forwarders/${id}`, body)).data,
  remove: async (id: string): Promise<void> => { await apiClient.delete(`/forwarders/${id}`); },
};
